module.exports = __webpack_public_path__ + "img/endas-logo.6b869ea2.jpg";